import { ChainId } from '@abstra-dex/sdk'
import { createAction } from '@reduxjs/toolkit'
import { Field } from 'state/swap/actions'

export const selectCurrency =
  createAction<{ field: Field; currencyId: string; chainId: ChainId }>('cross-chain/selectCurrency')
export const switchCurrencies = createAction<void>('cross-chain/switchCurrencies')

export const typeInput = createAction<{ field: Field; typedValue: string }>('cross-chain/typeInput')
